export default {
  name: 'App',
};
